export default {
  name: 'App',
};
